"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingMixin = void 0;
var _inlineMediaQueryMixin = require("./inlineMediaQueryMixin");
var _spaceMixin = require("./spaceMixin");
/** @mixin paddingMixin */
/**
 * Adds padding props.
 *
 * <ul>
 *     <li><code>padding</code></li>
 *     <li><code>paddingX</code></li>
 *     <li><code>paddingY</code></li>
 *     <li><code>paddingTop</code></li>
 *     <li><code>paddingBottom</code></li>
 *     <li><code>paddingLeft</code></li>
 *     <li><code>paddingRight</code></li>
 * </ul>
 *
 * @example
 * import { paddingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${paddingMixin}
 * `;
 *
 * <Component padding="xl" paddingTop="lg" paddingX="md" />
 * <Component padding={{ default: 'sm', md: 'lg' }} />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
var paddingMixin = function paddingMixin(props) {
  var styles = [];
  if ('padding' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('padding', function (mediaProps) {
      return "padding: " + (0, _spaceMixin.spaceMixin)(mediaProps.padding)(mediaProps) + ";";
    })(props));
  }
  if ('paddingX' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingX', function (mediaProps) {
      return "\n                    padding-left: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingX)(mediaProps) + ";\n                    padding-right: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingX)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('paddingY' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingY', function (mediaProps) {
      return "\n                    padding-top: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingY)(mediaProps) + ";\n                    padding-bottom: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingY)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('paddingTop' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingTop', function (mediaProps) {
      return "padding-top: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingTop)(mediaProps) + ";";
    })(props));
  }
  if ('paddingBottom' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingBottom', function (mediaProps) {
      return "padding-bottom: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingBottom)(mediaProps) + ";";
    })(props));
  }
  if ('paddingLeft' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingLeft', function (mediaProps) {
      return "padding-left: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingLeft)(mediaProps) + ";";
    })(props));
  }
  if ('paddingRight' in props) {
    styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('paddingRight', function (mediaProps) {
      return "padding-right: " + (0, _spaceMixin.spaceMixin)(mediaProps.paddingRight)(mediaProps) + ";";
    })(props));
  }
  return styles;
};
exports.paddingMixin = paddingMixin;